import React, { useState, useEffect } from 'react';
import "../css/Aboutme.css";

const highlights = [
  {
    label: 'Frontend',
    text: 'I breathe life into pixels with cutting-edge technologies, ensuring every user experience is unforgettable.',
  },
  {
    label: 'Backend',
    text: 'Turning data into gold, one efficient API at a time.',
  },
  {
    label: 'Debugging',
    text: 'Got a tricky bug? I’ll debug it faster than you can say "Stack Overflow"; but not as fast as AI nowadays.',
  },
];

function AboutMe() {
  const [years, setYears] = useState(0);
  const [engineeringYears, setEngineeringYears] = useState(0);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = 1991;
    const elapsedYears = currentYear - startYear;
    setYears(elapsedYears);
  }, []);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = 2014;
    setEngineeringYears(currentYear - startYear);
  }, []);

  const stats = [
    { value: `${engineeringYears}+`, label: 'years in software engineering' },
    { value: '19M+', label: 'guests served by systems I’ve shipped' },
    { value: '3', label: 'industries: ticketing, insurance, VR' },
  ];

  return (
    <section className="about">
      <header className="section-head">
        <span className="section-eyebrow">Based in London</span>
        <h1 className="section-title">About me</h1>
        <div className="section-meta">
          <span className="section-meta-item">{years} years</span>
          <span className="section-meta-item">London</span>
          <span className="section-meta-item">Remote employee</span>
        </div>
      </header>

      <dl className="about-stats">
        {stats.map(({ value, label }) => (
          <div className="about-stat" key={label}>
            <dt className="about-stat-value">{value}</dt>
            <dd className="about-stat-label">{label}</dd>
          </div>
        ))}
      </dl>

      <p className="prose-lead">
        Self-proclaimed tech enthusiast, code whisperer, and eternal student of
        the digital universe.
      </p>

      <p className="prose prose-muted">
        With {years} years of life experience and a base in London, I&rsquo;ve dedicated
        my career to crafting elegant solutions for complex problems. My fascination
        with technology sparked at a young age, inspired by watching my dad. Whether it
        was tinkering with an old laptop, programming rudimentary robots, or diving into
        the boundless world of coding, I was hooked. Today, I&rsquo;ve transformed that
        childhood curiosity into both a rewarding career and a lifelong passion.
      </p>

      <ul className="about-highlights">
        {highlights.map(({ label, text }) => (
          <li key={label} className="about-highlight">
            <span className="about-highlight-label">{label}</span>
            <span className="about-highlight-text">{text}</span>
          </li>
        ))}
      </ul>

      <p className="prose prose-muted">
        When I&rsquo;m not coding, I treasure spending time with my wife, son and my dog
        (Bruno), when possible bonding over our new shared love for Formula 1 or walking
        around the city. You might also find me gaming, exploring captivating sci-fi
        worlds, indulging in high-quality Japanese anime, or geeking out over the latest
        tech gadgets (yes, I&rsquo;ve probably already pre-ordered the one you&rsquo;re
        thinking of).
      </p>
    </section>
  );
}

export default AboutMe;
